import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { EkeyRedirectPageComponent } from './intgration/ekey-redirect-page/ekey-redirect-page.component';
import { EkeyLoginComponent } from './intgration/ekey-login/ekey-login.component';
import { EmailLoginComponent } from './email-login/email-login.component';
import { EmailLoginIntegrationComponent } from './email-login-integration/email-login-integration.component';
import {EmailActivation} from "./email-activation/email-activation.component";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import { EKeyIntegrationLoginComponent } from './ekey-integration-login/ekey-integration-login.component';
export const routes: Routes = [
  { path: '', component: LoginComponent},
  { path: 'ekey', component: EkeyLoginComponent},
  { path: 'redirect', component: EkeyRedirectPageComponent},
  { path: 'email', component: EmailLoginComponent},
  { path: 'email-activation', component: EmailActivation },
  { path: 'email-integration',component:EmailLoginIntegrationComponent},
  { path: 'forget-password',component: ForgotPasswordComponent},
  { path: 'reset-password',component: ResetPasswordComponent},
  { path: 'ekey-integration-redirect',component: EKeyIntegrationLoginComponent},
];

@NgModule({ 
  imports: [
    RouterModule.forChild(routes)
  ]
})

export class LoginRouting { }